// extracted by mini-css-extract-plugin
export default {"cta":"OH-z","disabled":"PH-z"};